var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { attrs: { height: 260, preserveAspectRatio: "none" } },
    [
      _c("rect", {
        attrs: { x: "0", y: "40", rx: "4", ry: "4", width: "150", height: "20" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "80", rx: "4", ry: "4", width: "180", height: "10" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "100",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "40",
          rx: "4",
          ry: "4",
          width: "150",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "80",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "100",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "140",
          rx: "4",
          ry: "4",
          width: "150",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "180",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "0",
          y: "200",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "140",
          rx: "4",
          ry: "4",
          width: "150",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "180",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "210",
          y: "200",
          rx: "4",
          ry: "4",
          width: "180",
          height: "10"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59a588a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59a588a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/resources/ResourceLoadingSkeleton.vue
// module id = null
// module chunks = 